import API from "../services/api";
import EventWaitingListEntry from "../models/event/EventWaitingListEntry";

export default class EventWaitingListRepository {
    static all = (event, period = null) => API.get('/event/waiting-list/all?event=' + event + (period ? '&period=' + period : '')).then(response => response.data.waiting_list.map(item => EventWaitingListEntry.fromJson(item)));
}
